class ProductTrustUSPs extends HTMLElement {
  constructor() {
    super();
    this.carousel = this.querySelector('.swiper');
    this.animationElements = this.querySelectorAll('.animate-on-scroll');

    if (this.carousel) {
      this.initCarousel();
    }

    if (this.animationElements.length > 0) {
      this.initAnimations();
    }
  }

  initCarousel() {
    const autoplayEnabled = this.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 3000;
    const requestedLoop = this.dataset.infinite === 'true';
    const allowSwipe = this.dataset.swipe === 'true';

    const mobileCols = parseInt(this.dataset.mobileCols) || 3;
    const gap = parseInt(this.dataset.gap) || 10;

    const mobileLayout = this.dataset.mobileLayout || 'carousel';

    const slideCount = this.querySelectorAll('.swiper-slide').length;

    // Loop sirf tabhi ON karo jab slides kaafi ho, warna bullets/click break ho jaate hain
    const safeLoop = requestedLoop && slideCount > mobileCols * 2;

    const init = () => {
      if (typeof Swiper === 'undefined') {
        setTimeout(init, 100);
        return;
      }

      // Purana instance ho to destroy kar do (theme editor re-render / duplicate init se bachne ke liye)
      if (this.carousel.swiper) {
        this.carousel.swiper.destroy(true, true);
      }

      const swiperOptions = {
        slidesPerView: mobileCols,
        spaceBetween: gap,
        loop: safeLoop,
        allowTouchMove: allowSwipe,
        watchOverflow: true,

        breakpoints: {
          0: {
            enabled: mobileLayout === 'carousel',
            slidesPerView: mobileCols,
            spaceBetween: gap
          },
          768: {
            enabled: false
          }
        },

        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev')
        },

        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        }
      };

      if (autoplayEnabled) {
        swiperOptions.autoplay = {
          delay: autoplaySpeed,
          disableOnInteraction: false
        };
      }

      const swiperInstance = new Swiper(this.carousel, swiperOptions);

      // Bulletproof fix: CSS load/cache pe depend na karke wrapper ko force flex karo
      const wrapperEl = this.carousel.querySelector('.swiper-wrapper');
      if (wrapperEl) {
        wrapperEl.style.display = 'flex';
        wrapperEl.style.flexWrap = 'nowrap';
      }

      // Images load hone ke baad Swiper ko recalculate karwao (pagination/overflow sahi hone ke liye)
      const images = this.carousel.querySelectorAll('img');
      const totalImages = images.length;
      let loadedCount = 0;

      const triggerUpdate = () => {
        loadedCount++;
        if (loadedCount === totalImages) {
          swiperInstance.update();
        }
      };

      if (totalImages === 0) {
        swiperInstance.update();
      } else {
        images.forEach((img) => {
          if (img.complete) {
            triggerUpdate();
          } else {
            img.addEventListener('load', triggerUpdate);
            img.addEventListener('error', triggerUpdate);
          }
        });
      }

      // Extra safety: window load pe bhi ek aur update (fonts/late-loading assets ke liye)
      window.addEventListener('load', () => {
        swiperInstance.update();
      });
    };

    init();
  }

  initAnimations() {
    const animationType = this.dataset.animation;
    const stagger = this.dataset.stagger === 'true';

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          const delay = stagger ? index * 150 : 0;
          setTimeout(() => {
            entry.target.classList.add(`animate-${animationType}`);
            entry.target.classList.remove('animate-on-scroll');
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    this.animationElements.forEach(el => observer.observe(el));
  }
}

customElements.define('product-trust-usps', ProductTrustUSPs);